import React, { useEffect, useState } from 'react';

const DevToolsProduction = () => {
	const [showDevtools, setShowDevtools] = useState(false);
	const ReactQueryDevtoolsProduction = React.lazy(() =>
		import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
			default: d.ReactQueryDevtools,
		})),
	);

	useEffect(() => {
		// @ts-expect-error - it might throw an error as the method is not on window type
		// it might throw an error as the method is not on window type

		window.toggleDevtools = () => setShowDevtools((old) => !old);
	}, []);

	return (
		showDevtools && (
			<React.Suspense fallback={null}>
				<ReactQueryDevtoolsProduction />
			</React.Suspense>
		)
	);
};

export default DevToolsProduction;
